// extracted by mini-css-extract-plugin
module.exports = {"cards":"basicCards_cards__9iv5W","subheadline":"basicCards_subheadline__CEuRC","cardInner":"basicCards_cardInner__YDM4x"};